import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardHeader, Divider, Avatar, CardContent, CardActions, Button, Typography, Link } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Help } from '@mui/icons-material';
import { useAsyncFunc } from '@inner-source/cis-shared/hooks';
import { ErrorMessage, NoData } from '@inner-source/cis-shared/components';
import { getPagesByLabel } from '@inner-source/cis-shared/services';
import { HowToList } from '../../../../components';
import { HowToSkeleton } from './components';

const confluenceUrl = `${process.env.NX_CONFLUENCE_URL}/howto`;

const HowTo = () => {
  const [pages, setPages] = useState();

  const [doGetPages, loading, error] = useAsyncFunc(
    useCallback(async () => {
      if (!pages) {
        const response = await getPagesByLabel({ label: 'howto', limit: 6 });
        setPages(response && response.pages);
      }
    }, [pages]),
  );

  useEffect(() => {
    doGetPages();
  }, [doGetPages]);

  return (
    <Card variant="outlined" sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'rgb(1,112,192)' }}>
            <Help />
          </Avatar>
        }
        title={<Typography variant="h6">HowTo</Typography>}
      />
      <Divider />
      <CardContent sx={{ pt: 0, display: 'flex', flexDirection: 'column', flex: 1 }}>
        {error && <ErrorMessage onRetry={doGetPages} />}
        {!error && loading && <HowToSkeleton />}
        {!error && !loading && pages && pages.length === 0 && <NoData />}
        {!error && !loading && pages && pages.length > 0 && <HowToList pages={pages} />}
      </CardContent>
      <Divider />
      <CardActions sx={{ pl: 3, display: 'flex' }}>
        <Button variant="text" color="primary" component={Link} href={confluenceUrl} target="_blank">
          See all
        </Button>
      </CardActions>
    </Card>
  );
};

export default HowTo;
